(function () {
  'use strict';

  var terms = [
    '3D Printers',
    'Filmmakers',
    'Photographers',
    "First AC's",
    'Camera Operators',
    "DOP's",
    'Sound Recordists',
    'Gaffers',
    'Product Designers',
    'Directors',
    'DITs'
  ];

  var settings = {
    displayDuration:    3500,
    transitionDuration: 400,
    startDelay:         800
  };

  var el           = null;
  var currentIndex = 0;
  var timer        = null;

  function showTerm() {
    var term = terms[currentIndex % terms.length];

    el.textContent = term;
    el.classList.remove('pba-exiting');
    void el.offsetWidth; // force reflow so animation restarts
    el.classList.add('pba-entering');

    timer = setTimeout(hideTerm, settings.displayDuration);
  }

  function hideTerm() {
    el.classList.remove('pba-entering');
    el.classList.add('pba-exiting');

    setTimeout(function () {
      currentIndex++;
      showTerm();
    }, settings.transitionDuration);
  }

  function init() {
    el = document.getElementById('pba-text');
    if (!el) return;

    setTimeout(showTerm, settings.startDelay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
